<div class="modal-header">
  <h4 class="modal-title">Select Department</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="onCancel()" ></button>
</div>
<div class="modal-body">
  <div class="col">
    @if (nodes && nodes.length) {
      <ps-hierarchy [selectedNode]="selectedNode" [nodes]="nodes" [multiSelect]="false"
        (nodeSelectionChanged)="setSelected($event)"
        id="departments">
      </ps-hierarchy>
    }
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="onSelect()"><span class="fa fa-check"></span> Select</button>
  <button type="button" class="btn btn-default" (click)="onCancel()"><span class="fa fa-close"></span> Close</button>
</div>
